module.exports = __webpack_public_path__ + "static/media/BAE0280+3.bdf4929f.jpg";